import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link,useLocation } from 'react-router-dom';

import { uiActions } from '../../store';

import { ChamProjectsOpenButton, ChamProjectsSaveButton } from '../ChamProjects/ChamProjects';
import PrintLink from '../PrintLink/PrintLink';

import styles from './TopMenu.module.css';

import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';
import logo from './assets/logo.png';

export default function TopMenu({ extended }) {
    const location = useLocation();
    const isOnVisualizerPage = location.pathname.includes('visualizer');

    // Holds the mobile menu open/closed status
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    
    const planDataDump = useSelector((state) => state.visualizer.activeFloorPlanData);
    const stepsDataDump = useSelector((state) => state.visualizer.activeFloorPlanSteps);


    const dispatch = useDispatch();

    // Update mobile menu status on the hamburger icon click
    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const handleShareModalButtonClick = function () {
        dispatch(uiActions.setShareModalActive(true));
    }

    const handleHelpModalButtonClick = function () {
        dispatch(uiActions.setHelpModalActive(true));
    }

    const handleFeedbackModalButtonClick = function () {
        dispatch(uiActions.setFeedbackModalActive(true));
    }

    const handleSendToSeagateModalButtonClick = function () {
        dispatch(uiActions.setSendToSeagateModalActive(true));
    }

    const dumpData = function() {
        localStorage.setItem("dataDump",JSON.stringify({
            home:planDataDump,
            selections:stepsDataDump
        }))
        window.open("/integration.html", "_blank");
    }

    const onProd = window.location.href.indexOf("localhost") == -1 && window.location.href.indexOf("staging") == -1;

    return (
        <section className={styles.topMenu}>
            <nav aria-label="Main Navigation">
                <ul className={!isMobileMenuOpen ? styles.closed : ''}>

                    <li className={styles.logo}>
                        <Link to="/" aria-label="Home">
                        <img src={logo} alt="Company Logo" />
                        </Link>
                    </li>


                    <li className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </li>
                    <div className={styles.navLinks}>
                    {extended && (

        
                    <li>
                        <Link to="/floorplans">Floor plans</Link>
                    </li>
                    )}
{/* 
                    {extended && (
                        <li>
                            <Link to="/roomscenes" aria-label="New scene Button">New Scene</Link>
                        </li>
                    )} */}

                    {/* <li>
                        <ChamUploadButton title="Upload" className="" aria-label="Upload Button" />
                    </li> */}

                    <li>
                        <ChamProjectsOpenButton title="My Projects" className="" aria-label="My Projects Button" />
                    </li>

                    {extended && (<>
                        <li>
                            <ChamProjectsSaveButton title="Save" className="" aria-label="Save Button" />
                        </li>

                        <li>
                            <PrintLink />
                        </li>

                        <li>
                            <button type="button" onClick={handleShareModalButtonClick} aria-label="Share">
                                <span>Share</span>
                            </button>
                        </li>

                        <li>
                            <button type="button" onClick={handleFeedbackModalButtonClick} aria-label="Feedback">
                                <span>Feedback</span>
                            </button>
                        </li>
                    </>

                    )}

                        <li>
                            <button type="button" onClick={handleHelpModalButtonClick} aria-label="Share">
                                <span>Help</span>
                            </button>
                        </li>
                        { isOnVisualizerPage && onProd && (<>
                            <li>
                                <button className={styles.sendBtn} onClick={handleSendToSeagateModalButtonClick} type="button" aria-label="Website">
                                    <span>Send to SeaGate Homes</span>
                                </button>
                            </li>
                            
                        </>
                        )
                        }

                        { isOnVisualizerPage && !onProd && (<>
                            <li>
                                <button className={styles.sendBtn} onClick={dumpData} type="button" aria-label="Website">
                                    <span>Integration Test</span>
                                </button>
                            </li>
                            
                        </>
                        )
                        }
                        
                        </div>
                </ul>
            </nav>
        </section>
    );
}

